module.exports = __webpack_public_path__ + "static/avatar-6c4ccc12924240bdbdd53a666c9dc583.jpg";